import { render } from "./PermissionsDataTable.vue?vue&type=template&id=df6f99f6&ts=true"
import script from "./PermissionsDataTable.vue?vue&type=script&lang=ts"
export * from "./PermissionsDataTable.vue?vue&type=script&lang=ts"

import exportComponent from "/var/www/html/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__